import { getApiBasePath } from "@/app/base-path";
declare global {
  var grecaptcha:
    | {
        enterprise?: {
          ready: (cb: () => void) => void;
          execute: (sitekey: string, opts: { action: string }) => Promise<string>;
        };
      }
    | undefined;
}

export type RecaptchaVerifyResponse = {
  success: boolean;
  score?: number;
  reason?: string;
};

const RECAPTCHA_TOKEN_TIMEOUT_MS = 10_000;

function getRecaptchaToken(action: string, siteKey: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const enterprise = globalThis.grecaptcha?.enterprise;
    if (!enterprise) {
      reject(new Error("recaptcha_not_loaded"));
      return;
    }
    if (!siteKey) {
      reject(new Error("recaptcha_site_key_missing"));
      return;
    }

    const timeoutId = globalThis.setTimeout(() => {
      reject(new Error("recaptcha_timeout"));
    }, RECAPTCHA_TOKEN_TIMEOUT_MS);

    enterprise.ready(() => {
      enterprise.execute(siteKey, { action }).then(
        (token) => {
          globalThis.clearTimeout(timeoutId);
          resolve(token);
        },
        (error) => {
          globalThis.clearTimeout(timeoutId);
          reject(error);
        },
      );
    });
  });
}

export async function verifyRecaptcha(
  action: string,
  siteKey: string,
): Promise<RecaptchaVerifyResponse> {
  const token = await getRecaptchaToken(action, siteKey);
  const response = await fetch(`${getApiBasePath()}/api/verify-recaptcha/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, action }),
  });
  return response.json();
}
